import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// TypeScript types for published_jobs table
export interface PublishedJob {
  id: string
  raw_jobs_id: string
  company_id: string | null
  job_title: string
  company_name: string
  company_name_full: string
  job_posted_at: string
  job_url: string | null

  // Location arrays
  city: string[] | null
  state: string[] | null
  country: string[] | null
  region: string[] | null

  // Remote work
  remote_eligibility: 'none' | 'state' | 'country' | 'region' | 'global' | null
  remote_states: string[] | null
  remote_countries: string[] | null
  remote_regions: string[] | null
  work_setting: 'on-site' | 'hybrid' | 'remote' | null
  work_setting_reasoning: string | null

  // Compensation
  salary_min: number | null
  salary_max: number | null
  salary_currency: string | null
  bonus: boolean
  equity: boolean
  variable_compensation: boolean
  compensation_reasoning: string | null

  // Role classification
  seniority: string | null
  seniority_reasoning: string | null
  job_family: string | null
  technical_role: boolean
  people_manager: boolean
  visa_sponsorship: boolean
  travel_required: boolean
  years_experience: number | null
  education: string | null
  timezone_required: string | null

  // Company metadata (from join)
  logo_url: string | null
  company_logo_url: string | null
  company_industry: string | null
  company_funding_stage: string | null
  company_active_jobs: number | null
  website_url: string | null
  description: string | null
  description_short: string | null
  employee_range: string | null
  total_funding: string | null
  funding_stage: string | null
  last_funding_date: string | null
  last_funding_amount: string | null
  linkedin_url: string | null
  founders: string | null
  founded_year: string | null
  investors: string | null
  active_jobs: number | null
  new_jobs_last_30d: number | null
  industry: string | null
  company_type: string | null
  headquarters: string | null
  key_benefits: string[] | null

  // Role description
  role_statement: string | null
  role_statement_confidence: string | null

  // Metadata
  created_at: string
  updated_at: string
}

// TypeScript types for raw_jobs table
export interface RawJob {
  id: string
  company_name: string
  job_title: string
  job_url: string | null
  job_posted_at: string
  is_active: boolean
  ats_type: string | null
}

// TypeScript types for companies table
export interface Company {
  slug: string
  name: string
  logo_url: string | null
  description_short: string | null
  website_url: string | null
  employee_range: string | null
  funding_stage: string | null
  headquarters: string | null
  industry: string | null
  hires_remote: boolean | null
  remote_locations: string[] | null
  remote_locations_updated_at: string | null
}

// TypeScript types for featured table
export interface FeaturedJob {
  company_name: string
  name: string
  job_title: string
  job_url: string
  logo_url: string | null
  hm_photo: string | null
  hiring_manager: string | null
  hm_role: string | null
  hm_blurb: string | null
  badges: string[] | null
  listed: boolean | null
}
